import React from "react";
import { IPaperCVContent } from "../PaperCVContent";

interface ICVNotesProps {
  content: IPaperCVContent;
  notes?: string;
}

export const CVNotes: React.FC<React.PropsWithChildren<ICVNotesProps>> = ({
  content,
  notes,
}) => (
  <div className="c-paper-cv__cv-notes">
    <span>{content.noteLabel}</span>
    {notes}
  </div>
);
